import { render } from "./Collectors.vue?vue&type=template&id=ea915af0&scoped=true"
import script from "./Collectors.vue?vue&type=script&lang=js"
export * from "./Collectors.vue?vue&type=script&lang=js"

import "./Collectors.vue?vue&type=style&index=0&id=ea915af0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea915af0"]])

export default __exports__